import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { Menu } from "@headlessui/react";
import { NavLink } from "react-router-dom";
import { DropdownMenuItemBase } from "./styles";
export const DropdownMenuItem = ({ children, ...props }) => (_jsx(Menu.Item, { as: 
    // If menu item is link but is disabled, render component as fragment to prevent navigation.
    props.asLink && !props.disabled ? NavLink : Fragment, ...props, children: ({ active, disabled }) => (_jsx(DropdownMenuItemBase, { active: active, disabled: disabled, children: children })) }));
